import React from 'react';
import { Card, Button, Space, Alert, Typography } from 'antd';
import { BugOutlined, ThunderboltOutlined } from '@ant-design/icons';
import simpleErrorHandler from '../utils/simpleErrorHandler';
import errorLogger from '../utils/errorLogger';

const { Title, Text } = Typography;

const TestError: React.FC = () => {
  const testSimpleError = () => {
    try {
      throw new Error('简单错误处理器测试 - ' + new Date().toLocaleTimeString());
    } catch (error) {
      simpleErrorHandler.logError(error, 'TestError');
      alert('简单错误已记录！');
    }
  };

  const testComplexError = () => {
    try {
      throw new Error('复杂错误处理器测试 - ' + new Date().toLocaleTimeString());
    } catch (error) {
      errorLogger.logError(error, 'TestError', { test: true });
      alert('复杂错误已记录！');
    }
  };

  const testNetworkError = () => {
    // 模拟网络错误
    const networkError = new Error('ECONNRESET: Connection reset by peer');
    (networkError as any).code = 'ECONNRESET';
    simpleErrorHandler.logError(networkError, 'TestError');
    alert('网络错误已记录！');
  };

  const testSocketError = () => {
    // 模拟Socket.IO错误
    const socketError = new Error('Socket.IO connection failed');
    (socketError as any).type = 'TransportError';
    simpleErrorHandler.logError(socketError, 'TestError');
    alert('Socket.IO错误已记录！');
  };

  const printErrors = () => {
    simpleErrorHandler.printSummary();
    console.log('简单错误列表:', simpleErrorHandler.getErrors());
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card>
        <Title level={2}>
          <BugOutlined /> 错误测试页面
        </Title>
        
        <Alert
          message="错误测试工具"
          description="点击下面的按钮来测试不同的错误记录功能。所有错误都会被记录到错误日志系统中。"
          type="info"
          style={{ marginBottom: '20px' }}
        />

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={4}>基础错误测试</Title>
            <Space>
              <Button type="primary" onClick={testSimpleError}>
                测试简单错误
              </Button>
              <Button onClick={testComplexError}>
                测试复杂错误
              </Button>
            </Space>
          </div>

          <div>
            <Title level={4}>网络错误测试</Title>
            <Space>
              <Button type="dashed" onClick={testNetworkError}>
                测试网络错误 (ECONNRESET)
              </Button>
              <Button type="dashed" onClick={testSocketError}>
                测试Socket.IO错误
              </Button>
            </Space>
          </div>

          <div>
            <Title level={4}>调试工具</Title>
            <Space>
              <Button icon={<ThunderboltOutlined />} onClick={printErrors}>
                打印错误摘要到控制台
              </Button>
            </Space>
          </div>

          <Alert
            message="查看错误记录"
            description={
              <div>
                <p>1. 访问 <Text code>/admin/simple-errors</Text> 查看简单错误记录</p>
                <p>2. 访问 <Text code>/admin/error-monitor</Text> 查看完整错误监控</p>
                <p>3. 打开浏览器开发者工具查看控制台输出</p>
              </div>
            }
            type="success"
          />
        </Space>
      </Card>
    </div>
  );
};

export default TestError;














